import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-promo-code-modal',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class PromoCodeModalComponent {
  promoCodesModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);

  redeemBonus() {
    this.eventManager.closeModal(new Modal(this.promoCodesModalData.id, ModalType.Persisted, this.promoCodesModalData));
  }
}
